module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "form"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/fire.png")
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Burn it Down")]), _vm._v(" "), _c('p', [_vm._v("Track your daily burnt points.")]), _vm._v(" "), _c('h3', [_vm._v("History")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [(_vm.isEmpty) ? _c('p', {
    staticClass: "empty"
  }, [_vm._v("No sprints to show.")]) : _vm._e(), _vm._v(" "), (!_vm.isEmpty) ? _c('table', [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.history), function(sprint) {
    return _c('tr', [_c('td', {
      staticClass: "col-left"
    }, [_vm._v(_vm._s(sprint.id))]), _vm._v(" "), _c('td', {
      staticClass: "col-left"
    }, [_vm._v(_vm._s(sprint.name))]), _vm._v(" "), _c('td', {
      staticClass: "col-right"
    }, [_vm._v(_vm._s(sprint.days))]), _vm._v(" "), _c('td', {
      staticClass: "col-right"
    }, [_vm._v(_vm._s(sprint.points))]), _vm._v(" "), _c('td', {
      staticClass: "col-right"
    }, [_vm._v(_vm._s(sprint.pointsPerDay.toFixed(2)))]), _vm._v(" "), _c('td', [_c('link-to', {
      attrs: {
        "href": ("#/sprint/" + (sprint.id))
      }
    }, [_vm._v("View")])], 1), _vm._v(" "), _c('td', [_c('link-to', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v("Stats")])], 1), _vm._v(" "), _c('td', [_c('link-to', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.deleteSprint.bind(this, sprint.id)
        }
      }
    }, [_vm._v("Delete")])], 1)])
  }))]) : _vm._e()]), _vm._v(" "), _c('link-to', {
    attrs: {
      "href": "#/"
    }
  }, [_vm._v("Go back")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "col-left"
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticClass: "col-left"
  }, [_vm._v("Sprint Name")]), _vm._v(" "), _c('th', {
    staticClass: "col-right"
  }, [_vm._v("Days")]), _vm._v(" "), _c('th', {
    staticClass: "col-right"
  }, [_vm._v("Points")]), _vm._v(" "), _c('th', {
    staticClass: "col-right"
  }, [_vm._v("Points per Day")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f21218d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sprints.vue
// module id = 550
// module chunks = 1